
define('text!templates/modules/questionnaire/questions/edit/question-edit-form.html',[],function () { return '<div class="info-section">\n    <div class="question-edit-form form-section">\n\n        <div class="name-input"></div>\n        <div class="type-input"></div>\n\n        <div class="options-list"></div>\n\n    </div>\n</div>\n';});

